import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Format time from 24-hour to 12-hour format (e.g., "17:00" -> "5:00 PM")
 * CRITICAL: Used everywhere times are displayed to avoid 24-hour format
 */
export function formatTimeTo12Hour(time24: string): string {
  if (!time24) return '';
  
  const [hours, minutes] = time24.split(':').map(Number);
  const period = hours >= 12 ? 'PM' : 'AM';
  const hours12 = hours % 12 || 12; // Convert 0 to 12 for midnight
  
  return `${hours12}:${minutes.toString().padStart(2, '0')} ${period}`;
}

/**
 * Format date for emails WITHOUT timezone conversion
 * CRITICAL: Prevents the 1-day-early bug by parsing date components manually
 * Example: "2024-11-10" -> "Sunday, November 10, 2024"
 */
export function formatDateForEmail(dateString: string): string {
  // Parse YYYY-MM-DD manually to avoid timezone conversion
  const [year, month, day] = dateString.split('-').map(Number);
  const dateObj = new Date(year, month - 1, day, 12, 0, 0); // Use noon to avoid DST issues
  
  return dateObj.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
}

/**
 * Format date for display WITHOUT timezone conversion
 * CRITICAL: Same as formatDateForEmail but shorter format
 * Example: "2024-11-10" -> "Nov 10, 2024"
 */
export function formatDateForDisplay(dateString: string): string {
  const [year, month, day] = dateString.split('-').map(Number);
  const dateObj = new Date(year, month - 1, day, 12, 0, 0);
  
  return dateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}
